/**
 * MODO DEMO · UNA SOLA AUTORIDAD.
 *
 * Esta pregunta vivia repetida palabra por palabra en cuatro modulos:
 * `bankTransfer`, `communications`, `emails` y `stripe`. Cuatro copias de la
 * misma condicion son cuatro sitios donde puede cambiar una y no las otras, y
 * este interruptor decide si el dinero y los correos son reales. No es un sitio
 * donde convenga tener varias opiniones.
 *
 * Se extrae tal cual, sin cambiar el comportamiento: la condicion es la misma
 * que ya corria en produccion.
 */

/**
 * Esta el estudio operando en modo demostracion?
 *
 * La bandera la escribe la propia aplicacion (`AppContext.setDemoMode`, el
 * acceso demo del login) y vive en `localStorage`, asi que en un entorno sin
 * `window` la respuesta correcta es que NO: no hay operador ni sesion, y
 * suponer demo apagaria efectos que si debian ocurrir.
 */
import { modoQAEnvioRealActivo } from './qaEnvioReal';

export function modoDemoActivo() {
  return typeof window !== 'undefined'
    && window.localStorage?.getItem('feria_demo_mode') === 'true';
}

/**
 * Nace esta fila como prueba?
 *
 * El motor de branding no marcaba nada al crear, asi que una cotizacion hecha
 * en modo demo aparecia en el pipeline junto al negocio real: las
 * comunicaciones si quedaban suprimidas, pero la fila era indistinguible. Que
 * un QA no envie correos no basta; tambien tiene que poder reconocerse despues.
 *
 * DOS caminos la marcan, y son cosas distintas:
 *
 *   · modo demo — la experiencia entera es de mentira, los efectos externos
 *     quedan suprimidos y la fila no debe confundirse con negocio.
 *   · modo QA de envio real — la cotizacion es de prueba pero recorre el flujo
 *     REAL, para poder observar un envio de verdad. Es la doctrina de la
 *     migracion 195: `is_test` no cambia el codigo, solo acota los efectos.
 *
 * Antes esto era un alias de `modoDemoActivo()`, y eso hacia imposible tener
 * una cotizacion marcada como prueba que ejercitara el envio: el mismo
 * interruptor que la marcaba era el que apagaba el correo.
 */
export function creacionEsDePrueba() {
  return modoDemoActivo() || modoQAEnvioRealActivo();
}
